import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
import type { ExportSettings } from './ExportTypes'

export class PdfExport {
    constructor() {}

    /**
     * Exports the content of an element specified by element_id as a PDF.
     * @param exportSettings - The export settings containing type and element_id.
     */
    exportElement(exportSettings: ExportSettings): void {
        if (!exportSettings.element_id) {
            console.error('No element_id provided in export settings.')
            return
        }

        const element = document.getElementById(exportSettings.element_id)
        if (!element) {
            console.error(`Element with id ${exportSettings.element_id} not found.`)
            return
        }

        // console.log(`Exporting element with id: ${exportSettings.element_id}`)
        this.singelPageExport(element, exportSettings)
    }

    singelPageExport(element: HTMLElement, exportSettings: ExportSettings): void {
        html2canvas(element, { useCORS: true })
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png')
                const contentWidth = canvas.width
                const contentHeight = canvas.height
                // Convert pixels to mm for jsPDF (1 px = 0.264583 mm)
                const pxmm = 0.264583
                const pdfWidth = contentWidth * pxmm
                const pdfHeight = contentHeight * pxmm
                const pdf = new jsPDF('p', 'mm', [pdfWidth, pdfHeight])
                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight)
                pdf.save(`${exportSettings.element_id}.pdf`)
            })
            .catch((error) => {
                console.error('Error generating PDF:', error)
            })
    }
}
